import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function dingLogin(data) {
  return request({
    url: '/dingLogin',
    method: 'post',
    data
  })
}

/**
 * 获取用户基本信息
 * @returns {AxiosPromise}
 */
export function getInfo() {
  return request({
    url: '/ai/d/userInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function kuaJieLogin(data) {
  return request({
    url: '/dingLoginKuaJie',
    method: 'post',
    data
  })
}

export function deFengLogin(data) {
  return request({
    url: '/dingLoginDeFeng',
    method: 'post',
    data
  })
}
export function getTaskStart(data) {
  return request({
    url: '/ai/d/task/start',
    method: 'post',
    data
  })
}

export function getTaskEnd(data, id) {
  return request({
    url: `/ai/d/task/end/${id}`,
    method: 'PATCH',
    data
  })
}

export function getTaskAppend(data, id) {
  return request({
    url: `/ai/d/task/append/${id}`,
    method: 'PATCH',
    data
  })
}

// 查询当前进行中的任务（所有用户），用于批量中心左侧任务列表
// 接口未就绪时会轮询失败，支持 silent:true 跳过控制台日志
export function getActiveTasks({ silent = false } = {}) {
  return request({
    url: '/ai/d/task/active',
    method: 'get',
    silent
  })
}

export function updateConfig(data) {
  return request({
    url: '/ai/d/toolConfig/updateConfig',
    method: 'post',
    data
  })
}
